import { Tooltip as AntTooltip } from "antd";
import type { GA4PageMetric } from "@/services/ga4Service";

export interface EngagementTableProps {
	pages: GA4PageMetric[];
}

export function EngagementTable({ pages }: EngagementTableProps) {
	return (
		<div className="overflow-x-auto">
			<table className="w-full text-sm">
				<thead>
					<tr className="border-b bg-muted text-left text-xs font-medium text-muted-foreground">
						<th className="py-3 pl-5 pr-3">Page</th>
						<th className="py-3 pr-3 text-right"><AntTooltip title="Total times this page was viewed"><span>Page Views</span></AntTooltip></th>
						<th className="py-3 pr-3 text-right"><AntTooltip title="Number of visits that included this page"><span>Sessions</span></AntTooltip></th>
						<th className="py-3 pr-3 text-right"><AntTooltip title="Average time visitors spend on this page"><span>Avg Time</span></AntTooltip></th>
						<th className="py-3 pr-5 text-right"><AntTooltip title="% of visitors who left without interacting further"><span>Bounce Rate</span></AntTooltip></th>
					</tr>
				</thead>
				<tbody>
					{pages.map((page) => {
						const minutes = Math.floor(page.avg_time / 60);
						const seconds = page.avg_time % 60;
						const timeStr = `${minutes}:${seconds.toString().padStart(2, "0")}`;
						const bounceColor = page.bounce_rate < 0.35 ? "text-[hsl(var(--status-success))]" : page.bounce_rate > 0.42 ? "text-destructive" : "text-foreground";
						return (
							<tr key={page.page_path} className="border-b border-border transition-colors hover:bg-muted">
								<td className="max-w-[400px] py-3 pl-5 pr-3">
									<p className="truncate font-medium">{page.page_title}</p>
									<p className="truncate text-xs text-muted-foreground">{page.page_path}</p>
								</td>
								<td className="py-3 pr-3 text-right font-medium">{page.page_views.toLocaleString()}</td>
								<td className="py-3 pr-3 text-right">{page.sessions.toLocaleString()}</td>
								<td className="py-3 pr-3 text-right">{timeStr}</td>
								<td className={`py-3 pr-5 text-right font-medium ${bounceColor}`}>{(page.bounce_rate * 100).toFixed(1)}%</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
}
